import {useQuery} from "@tanstack/react-query";
import {readShipmentDeliveryConfirm} from "../../../../../api/order/OrdersApi";

type Props = {
    param: string;
};

export const useReadShipmentDeliveryConfirm = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readShipmentDeliveryConfirm", param],
        queryFn: async () => await readShipmentDeliveryConfirm(param),
        select: (res) => res?.data.result ?? null,
        enabled: param !== ""
    });

    return {data};
};
